export default "-- ClickBench Q15\nselect userid, count(*)\nfrom hits\ngroup by userid\norder by count(*) desc \nlimit 10;";